module.exports = __webpack_public_path__ + "media/images/icon__externalLink-4fc8ff1f8e3d632908b24308e17a116a.png";